import axios from 'axios';
import _e from './_endpoints';

const loginUrl:string = _e.getUrl('login');
const logoutUrl:string = _e.getUrl('logout');
const userInfoUrl:string = _e.getUrl('userInfo');

const authenticate = (payload:any) => axios.post(`${loginUrl}`, payload);
const logout = (payload:any) => axios.post(`${logoutUrl}`, payload);
const getUserInfo = () => axios.get(`${userInfoUrl}`);

export default {
    authenticate,
    logout,
    getUserInfo
}
